import React from 'react'
import { inject, observer } from 'mobx-react'
import ErrorForm from '../common/ErrorForm'
import { trackValue } from 'utils.js'
import { withTranslation } from 'react-i18next'
import AddTargetGroupIcon from '../../common/icons/AddTargetGroupIcon'
import PaneHeader from '../panes/PaneHeader'

const AddTargetGroupPane = ({
  uiStore, dataStore, selectionStore, t
}) => {
  const handleCancel = () => {
    selectionStore.clear()
  }

  const handleSubmit = (e) => {
    if (e && e.preventDefault) e.preventDefault()
    uiStore.addTargetGroup(dataStore.addTargetGroupForm)
  }

  return (
    <div className='line-pane add-target-group-pane'>
      <PaneHeader
        icon={AddTargetGroupIcon}
        title={t('TARGET_GROUP.ADD', { defaultValue: 'Add folder' })}
        onClose={handleCancel}
      />
      <form className='spaced-children' onSubmit={handleSubmit}>
        <section>
          <label>
            <span>{t('GLOBAL.NAME', { defaultValue: 'Name' })}</span>
            <input
              type='text'
              className='name-input'
              placeholder={t('TARGET_GROUP.NAME_PLACEHOLDER', { defaultValue: 'e.g. Q3 Expansion Locations' })}
              autoFocus
              {...trackValue(dataStore.addTargetGroupForm, 'name')}
            />
          </label>
          {dataStore.addTargetGroupForm.error && (
            <ErrorForm item={dataStore.addTargetGroupForm} />
          )}
        </section>
        <section>
          <div className='centered-button-row'>
            <button type='button' onClick={handleCancel}>
              <span>{t('GLOBAL.CANCEL', { defaultValue: 'Cancel' })}</span>
            </button>
            <button
              type='submit'
              className='ok'
            >
              <span>{t('GLOBAL.CONFIRM_ADD', { defaultValue: 'Create folder' })}</span>
            </button>
          </div>
        </section>
      </form>
    </div>
  )
}

export default withTranslation()(inject('uiStore', 'dataStore', 'selectionStore')(observer(AddTargetGroupPane)))
